const QueryKeys = {
	all: ["menu"],
	lists: () => [...QueryKeys.all, "list"],
	list: (filters: any) => [...QueryKeys.lists(), {filters}],
	details: () => [...QueryKeys.all, "detail"],
	detail: (id: string) => [...QueryKeys.details(), id]
}

export default QueryKeys
